import config from '../../config';
import {createPreloadableLazyComponent} from '../../util/lazyImport';
import {type RouteData} from '../types';
import {
  GLOBAL_HISTORIC_USAGE_PATH,
  GLOBAL_HISTORIC_USAGE_REDIRECT_PATH,
  GLOBAL_HISTORIC_USAGE_REDIRECT_TO_PATH,
  HISTORIC_USAGE_PATH,
  HISTORIC_USAGE_REDIRECT_PATH,
  HISTORIC_USAGE_REDIRECT_TO_PATH,
  STORAGE_EXPLORER_TRACKED_PATH,
  USAGE_PATH,
} from './usagePaths';

const IS_PRIVATE_ENV = config.ENVIRONMENT_IS_PRIVATE;

export const STORAGE_EXPLORER_ROUTES_DATA: RouteData[] = [
  {
    additionalProps: {
      allowIframes: false,
      datadogViewName: 'StorageExplorer',
    },
    exact: true,
    isPrivateRoute: false,
    path: [
      USAGE_PATH,
      STORAGE_EXPLORER_TRACKED_PATH,
      '/usage/:entityName/:filePath*',
    ],
    RouteComponent: createPreloadableLazyComponent(
      () => import('../../pages/StorageExplorer')
    ).Component,
  },
  {
    path: '/storage/:entityName/tracked/:filePath*',
    redirect: STORAGE_EXPLORER_TRACKED_PATH,
  },
  {
    path: '/storage/:entityName/:filePath*',
    redirect: '/usage/:entityName/:filePath*',
  },
  {
    path: '/storage/:entityName',
    redirect: '/usage/:entityName',
  },
];

export const HISTORIC_USAGE_ROUTES_DATA: RouteData[] = [
  {
    additionalProps: {
      allowIframes: false,
      datadogViewName: 'GlobalHistoricUsage',
    },
    condition: IS_PRIVATE_ENV,
    exact: true,
    isPrivateRoute: true,
    path: GLOBAL_HISTORIC_USAGE_PATH,
    RouteComponent: createPreloadableLazyComponent(
      () => import('../../pages/HistoricUsage/GlobalHistoricUsage')
    ).Component,
  },
  {
    condition: IS_PRIVATE_ENV,
    path: GLOBAL_HISTORIC_USAGE_REDIRECT_PATH,
    redirect: GLOBAL_HISTORIC_USAGE_REDIRECT_TO_PATH,
  },
  {
    additionalProps: {
      allowIframes: false,
      datadogViewName: 'OrganizationHistoricUsage',
    },
    condition: !IS_PRIVATE_ENV,
    exact: true,
    isPrivateRoute: true,
    path: HISTORIC_USAGE_PATH,
    RouteComponent: createPreloadableLazyComponent(
      () => import('../../pages/HistoricUsage/OrganizationHistoricUsage')
    ).Component,
  },
  {
    condition: !IS_PRIVATE_ENV,
    path: HISTORIC_USAGE_REDIRECT_PATH,
    redirect: HISTORIC_USAGE_REDIRECT_TO_PATH,
  },
];
